import { connect } from 'react-redux';

import { Link } from 'react-router-dom';
import { SILVER } from '../../../data/permissions';

import permissionsDecorator from '../../../decorators/permissionsDecorator';
import withComponentName from '../../../decorators/withComponentName';

export function WatchlistTopicsUpdateSuggestion({
  permissionsInitialized,
  maxWatchlistSize,
  accessLevels,
  showSuggestion,
}) {
  return permissionsInitialized && showSuggestion && (
    accessLevels.includes(SILVER) ? (
      <>
        You&apos;ve already added
        {` ${maxWatchlistSize} `}
        topics to this watchlist.
        Make another list or remove some topics.
      </>
    ) : (
      <>
        Your current plan allows
        {` ${maxWatchlistSize} `}
        topics per
        watchlist.&nbsp;
        <a href="/pricing">Upgrade</a>
        &nbsp;for more.
      </>
    )
  );
}

function mapToStateProps({ subscriptions, watchlistReducer }) {
  const { permissions, permissionsInitialized } = subscriptions;
  const { activeWatchlistTopics } = watchlistReducer;
  const {
    max_watchlist_size: maxWatchlistSize,
    access_levels: accessLevels,
  } = permissions;

  return {
    permissionsInitialized,
    maxWatchlistSize,
    accessLevels,
    showSuggestion: activeWatchlistTopics.length >= maxWatchlistSize,
  };
}

export default withComponentName(
  connect(mapToStateProps)(permissionsDecorator(WatchlistTopicsUpdateSuggestion)),
);
